import thumbnail from "../assets/images/thumbnail.png";
import logoPMMCsvgBlack from "../assets/images/logo-pmmc-preto.svg";
import logoPMMCsvgWhite from "../assets/images/logo-pmmc-branco.svg";
import logoPMMCsvgTransparent from "../assets/images/logo-pmmc-transp.svg";
import logoPMMCBrasaosvgWhite from "../assets/images/logo-pmmc-brasao-branco.svg";
import logoPMMCBrasaosvgBlack from "../assets/images/logo-pmmc-brasao-pb.svg";
import loadingSpinner from "../assets/images/loading_ca.json";
import gnutecaLogo from "../assets/images/gnutecaLogo.png";
import iconAgenda from "../assets/images/icon_agenda.json";
import iconAjuda from "../assets/images/icon_ajuda.json";
import iconAvaliacao from "../assets/images/icon_avaliacao.json";
import iconBiblioteca from "../assets/images/icon_biblioteca.json";
import iconConheca from "../assets/images/icon_conheca.json";
import iconDocumentos from "../assets/images/icon_documentos.json";
import iconFormacoes from "../assets/images/icon_formacoes.json";
import iconNotificacao from "../assets/images/icon_notificacao.json";
import iconPessoas from "../assets/images/icon_pessoas.json";
import iconPlataformas from "../assets/images/icon_plataformas.json";
import iconVideoteca from "../assets/images/icon_videoteca.json";
import iconMuve from "../assets/images/icon_muve.json";
import bannerBackground from "../assets/images/banner_bg_canal_pedagogico.svg";
import bannerBackgroundHighContrast from "../assets/images/banner_bg_canal_pedagogico_acessibilidade.svg";
import iconPerfil from "../assets/images/icon_perfil.json";
import iconLogin from "../assets/images/icon_login.json";
import cemforpe from "../assets/images/cemforpe2.jpg";
import simulados from "../assets/images/simulados.svg";
import migo from "../assets/images/migo.svg";
import eaprendi from "../assets/images/e-aprendi.svg";
import jornada from "../assets/images/jornada.svg";
import educacaoHumanizada from "../assets/images/educacao_humanizada.svg";
import matific from "../assets/images/matific.png";
import file from "../assets/images/file.png";
import shieldLock from "../assets/images/shield-lock.png";
import spy from "../assets/images/spy.png";
import apagar from "../assets/images/apagar.png";
import iconClip from "../assets/images/paper-clip.png";
import logoCidadeLeitora from "../assets/images/logo_cidadeleitora.png";
import icon_cidadeleitora from "../assets/images/icon_cidadeleitora.json";
import icon_student from "../assets/images/icon_student.json"
import icon_pnld from "../assets/images/icon_pnld.json";
import icon_musica from "../assets/images/icon_musica.json";
import note from "../assets/images/note.png";
import escola1 from "../assets/images/escolaambiental1.jpeg";
import escola2 from "../assets/images/escolaambiental2.png";
import manut from "../assets/images/manut.jpg";
import iconNovidades from "../assets/images/novidades.json";
import livrosEstado from "../assets/images/livros-estado.json";
import icon_jornada from "../assets/images/icon_jornada.json";

import certificadoPng from "../assets/images/certificado.png";
import certificadoSvg from "../assets/images/certificado.svg";

import certificadoPng_Rgb from "../assets/images/certificado-rgb.png";
import certificado_telas from "../assets/images/certificado-telas.svg";
import certificado_valido from "../assets/images/certificado-valido.svg";
import certificado_cancelado from "../assets/images/certificado-cancelado.svg";

import certificadoPng_Rgb_logo from "../assets/images/certificado-rgb-logo.png";
import certificado_telas_logo from "../assets/images/certificado-telas-logo.svg";
import certificado_valido_logo from "../assets/images/certificado-valido-logo.svg";
import certificado_cancelado_logo from "../assets/images/certificado-cancelado-logo.svg";

import certificado_2025_template from "../assets/images/certificado-2025-cmyk-10.png";

import certificado_valido_g from "../assets/images/certi-valido.png";
import certificado_cancelado_g from "../assets/images/certi-cancelado.png";


import reds_banner from "../assets/images/reds.json";
import ambiental_banner from "../assets/images/ambiental-banner.json";

import w3 from "../assets/images/banner_bg_canal_pedagogico.svg";
import fundobanner from "../assets/images/fundo-banner.png";
import fundobannerpage from "../assets/images/fundobannerpage.png";
import popup from "../assets/images/popup.jpg";


import math1 from "../assets/images/math1.jpg";
import math2 from "../assets/images/math2.jpg";
import math3 from "../assets/images/math3.jpg";
import math4 from "../assets/images/math4.jpg";
import math5 from "../assets/images/math5.jpg";
import math6 from "../assets/images/math6.jpg";
import math7 from "../assets/images/math7.jpg";
import math8 from "../assets/images/math8.jpg";

import bannerbrincar from "../assets/images/bannerbrincar.jpg";
// import bannerobmp from "../assets/images/bannerobmp.jpeg";
import bannerobmp from "../assets/images/OBEMEP2025.png";
import bannermcl from "../assets/images/MCL2025.png";



import recovery1 from "../assets/images/recovery1.jpg";
import recovery2 from "../assets/images/recovery2.jpg";

//Fotos funcionários
import adilson from "../assets/images/func/adilson.png";
import adriana from "../assets/images/func/adriana.png";
import alexandre from "../assets/images/func/alexandre.png";
import anacarol from "../assets/images/func/anacarol.png";
import andreia from "../assets/images/func/andreia.png";
import angelica from "../assets/images/func/angelica.png";
import angelo from "../assets/images/func/angelo.png";
import aniele from "../assets/images/func/aniele.png";
import beatriz from "../assets/images/func/beatriz.png";
import carlos from "../assets/images/func/carlos.png";
import carloskomoto from "../assets/images/func/carloskomoto.png";
import carolina from "../assets/images/func/carolina.png";
import cintia from "../assets/images/func/cintia.png";
import claudia from "../assets/images/func/claudia.png";
import daniele from "../assets/images/func/daniele.png";
import diaglo from "../assets/images/func/diaglo.png";
import dirce from "../assets/images/func/dirce.png";
import edgar from "../assets/images/func/edgar.png";
import elaine from "../assets/images/func/elaine.png";
import elisabete from "../assets/images/func/elisabete.png";
import elivandra from "../assets/images/func/elivandra.png";
import eneas from "../assets/images/func/eneas.png";
import eny from "../assets/images/func/eny.png";
import erivania from "../assets/images/func/erivania.png";
import fabricio from "../assets/images/func/fabricio.png";
import flavio from "../assets/images/func/flavio.png";
import gabicerqueira from "../assets/images/func/gabicerqueira.png";
import gilberto from "../assets/images/func/gilberto.png";
import gisele from "../assets/images/func/gisele.png";
import gustavo from "../assets/images/func/gustavo.png";
import henrique from "../assets/images/func/henrique.png";
import jefferson from "../assets/images/func/jefferson.png";
import joelma from "../assets/images/func/joelma.png";
import jose from "../assets/images/func/jose.png";
import kariny from "../assets/images/func/kariny.png";
import leandro from "../assets/images/func/leandro.png";
import lilian from "../assets/images/func/lilian.png";
import lucianacampos from "../assets/images/func/lucianacampos.png";
import lucianaleite from "../assets/images/func/lucianaleite.png";
import luizflavio from "../assets/images/func/luizflavio.png";
import mitch from "../assets/images/func/mitch.png";
import monicafelismino from "../assets/images/func/monicafelismino.png";
import monicasenziali from "../assets/images/func/monicasenziali.png";
import nayara from "../assets/images/func/nayara.png";
import neto from "../assets/images/func/neto.png";
import osmar from "../assets/images/func/osmar.png";
import pamela from "../assets/images/func/pamela.png";
import patricia from "../assets/images/func/patricia.png";
import paulo from "../assets/images/func/paulo.png";
import rafael from "../assets/images/func/rafael.png";
import rieko from "../assets/images/func/rieko.png";
import roberto from "../assets/images/func/roberto.png";
import soraya from "../assets/images/func/soraya.png";
import suellen from "../assets/images/func/suellen.png";
import valeria from "../assets/images/func/valeria.png";
import valter from "../assets/images/func/valter.png";
import vanessa from "../assets/images/func/vanessa.png";
import wander from "../assets/images/func/wander.png";
import rosana from "../assets/images/func/rosana.png";
import gabisalla from "../assets/images/func/gabisalla.png";
import marcatti from "../assets/images/func/marcatti.png";
import anamaria from "../assets/images/func/anamaria.png";
import andre from "../assets/images/func/andre.png";

// eslint-disable-next-line
export default {
  thumbnail,
  logoPMMCsvgBlack,
  logoPMMCsvgWhite,
  logoPMMCsvgTransparent,
  loadingSpinner,
  gnutecaLogo,
  iconAgenda,
  iconAvaliacao,
  iconBiblioteca,
  iconConheca,
  iconDocumentos,
  iconFormacoes,
  iconNotificacao,
  iconPessoas,
  iconPlataformas,
  iconVideoteca,
  iconPerfil,
  iconLogin,
  bannerBackground,
  cemforpe,
  simulados,
  migo,
  eaprendi,
  jornada,
  educacaoHumanizada,
  matific,
  iconAjuda,
  bannerBackgroundHighContrast,
  file,
  shieldLock,
  spy,
  iconClip,
  apagar,
  iconMuve,
  logoCidadeLeitora,
  icon_cidadeleitora,
  icon_student,
  icon_musica,
  icon_pnld,
  note,
  escola1,
  escola2,
  manut,
  iconNovidades,
  livrosEstado,
  certificadoPng,
  certificadoSvg,
  certificadoPng_Rgb,
  certificado_telas,
  certificado_valido,
  certificado_cancelado,
  certificadoPng_Rgb_logo,
  certificado_telas_logo,
  certificado_valido_logo,
  certificado_cancelado_logo,
  logoPMMCBrasaosvgWhite,
  logoPMMCBrasaosvgBlack,
  reds_banner,
  ambiental_banner,
  w3,
  fundobanner,
  fundobannerpage,
  popup,
  icon_jornada,
  certificado_2025_template,
  certificado_valido_g,
  certificado_cancelado_g,
  recovery1,
  recovery2,
  math1,
  math2,
  math3,
  math4,
  math5,
  math6,
  math7,
  math8,

  //banners
  bannerbrincar,
  bannerobmp,
  bannermcl,

  //funcionários
  adilson,
  adriana,
  andre,
  alexandre,
  anacarol,
  andreia,
  angelica,
  angelo,
  aniele,
  beatriz,
  carlos,
  carloskomoto,
  carolina,
  cintia,
  claudia,
  daniele,
  diaglo,
  dirce,
  edgar,
  elaine,
  elisabete,
  elivandra,
  eneas,
  eny,
  erivania,
  fabricio,
  flavio,
  gabicerqueira,
  gilberto,
  gisele,
  gustavo,
  henrique,
  jefferson,
  joelma,
  jose,
  kariny,
  leandro,
  lilian,
  lucianacampos,
  lucianaleite,
  luizflavio,
  mitch,
  monicafelismino,
  monicasenziali,
  nayara,
  neto,
  osmar,
  pamela,
  patricia,
  paulo,
  rafael,
  rieko,
  roberto,
  soraya,
  suellen,
  valeria,
  valter,
  vanessa,
  wander,
  gabisalla,
  rosana,
  marcatti,
  anamaria
};
